/* ==========================================================================
   TRY EVERYTHING SECTION — slider
   Scoped to the "try-everything" section only.

   Defined as a custom element so the file stays safe to evaluate more than
   once: the section renders its own <script> tag, so a page holding two
   Try Everything sections runs this file twice. The customElements guard
   makes the second run a no-op, and each element manages its own Swiper
   through connectedCallback / disconnectedCallback.
   ========================================================================== */

if (!customElements.get('try-everything-slider')) {
  customElements.define(
    'try-everything-slider',
    class TryEverythingSlider extends HTMLElement {
      constructor() {
        super();
        this.swiper = null;
        this.slider = null;
        this.syncTitleHeights = this.syncTitleHeights.bind(this);
      }

      connectedCallback() {
        this.slider = this.querySelector('.try-everything__swiper');
        if (!this.slider || typeof Swiper === 'undefined') return;

        this.init();

        window.addEventListener('resize', this.syncTitleHeights);

        if (document.fonts && document.fonts.ready) {
          document.fonts.ready.then(this.syncTitleHeights);
        }
      }

      disconnectedCallback() {
        window.removeEventListener('resize', this.syncTitleHeights);

        if (this.swiper) {
          this.swiper.destroy(true, true);
          this.swiper = null;
        }
      }

      init() {
        if (this.slider.swiper) {
          this.slider.swiper.destroy(true, true);
        }

        /* "Large" is only ever set by the section when there are 1 or 2 cards.
           Mobile caps a large card at the full container width so it can never
           overflow the viewport. */
        const isLarge = this.slider.dataset.cardWidth === 'large';
        const slidesPerView = isLarge
          ? { mobile: 1, tablet: 1.16875, desktop: 2 }
          : { mobile: 1.3346, tablet: 2.3375, desktop: 4 };

        this.swiper = new Swiper(this.slider, {
          slidesPerView: slidesPerView.mobile,
          spaceBetween: 12,
          watchOverflow: true,
          centerInsufficientSlides: true,
          observer: true,
          observeParents: true,

          breakpoints: {
            768: {
              slidesPerView: slidesPerView.tablet,
              spaceBetween: 20,
            },
            1025: {
              slidesPerView: slidesPerView.desktop,
              spaceBetween: 12,
            },
          },

          on: {
            init: this.syncTitleHeights,
            resize: this.syncTitleHeights,
            breakpoint: this.syncTitleHeights,
            observerUpdate: this.syncTitleHeights,
          },
        });
      }

      /* Keeps every card description on the same baseline, whatever the
         title length is, so the card content stays aligned across the row. */
      syncTitleHeights() {
        const titles = Array.from(this.querySelectorAll('.try-everything__card-title'));
        if (!titles.length) return;

        titles.forEach((title) => {
          title.style.minHeight = '';
        });

        const maxHeight = titles.reduce((max, title) => {
          const height = Math.ceil(title.getBoundingClientRect().height);
          return height > max ? height : max;
        }, 0);

        if (maxHeight > 0) {
          titles.forEach((title) => {
            title.style.minHeight = `${maxHeight}px`;
          });
        }
      }
    },
  );
}
